// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_PCx","cls2":"CiterightInline-cls2_71G CiterightInline-cls1_PCx"};